var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62758 7.30914L2.76783 0.47666C2.61743 0.325622 2.43849 0.20574 2.24134 0.12393C2.04419 0.0421197 1.83272 0 1.61915 0C1.40557 0 1.19411 0.0421197 0.996954 0.12393C0.799802 0.20574 0.620864 0.325622 0.470463 0.47666C0.169134 0.778582 0 1.187 0 1.61272C0 2.03844 0.169134 2.44686 0.470463 2.74878L6.1977 8.45326L0.470463 14.1577C0.169134 14.4597 0 14.8681 0 15.2938C0 15.7195 0.169134 16.1279 0.470463 16.4299C0.621636 16.5792 0.800922 16.6974 0.998038 16.7776C1.19515 16.8578 1.40623 16.8984 1.61915 16.8972C1.83207 16.8984 2.04314 16.8578 2.24026 16.7776C2.43737 16.6974 2.61666 16.5792 2.76783 16.4299L9.62758 9.59738C9.77922 9.44757 9.89958 9.26935 9.98171 9.07298C10.0639 8.87661 10.1061 8.66599 10.1061 8.45326C10.1061 8.24053 10.0639 8.02991 9.98171 7.83354C9.89958 7.63717 9.77922 7.45894 9.62758 7.30914Z",
    fill: "#006560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.d4863173953eda7b228786221264d3bc.svg";
export { ForwardRef as ReactComponent };